export default __webpack_public_path__ + "static/media/electric-stove-gray.b03922b9.svg";